'use strict';

require('../models/ascent/ascentTypes');
require('../helpers/show-modal-message/show-modal-message');

angular.module('far.forms.educationReportForm', [
    'dekky.forms',
    'far.models.ascentTypes',
    'far.helpers.showModalMessage'
])
.service('educationReportForm', function(
    form,
    autocomplete,
    ascentTypes,
    fileUploadFilters,
    showModalMessage
) {
    var reportModel = form('educationReportModel');
    var ascentModel = form('ascentModel');
    var userModel = form('userModel');

    userModel
        .addField('fio', 'uiTypeahead', {
            validators: {
                required: true
            },
            options: {
                placeholder: 'Участник',
                class: 'form__item width-350 margin_r_20',
                uibTypeahead: "row for row in field.refreshAutoComplete($viewValue, 'Users')",
                typeaheadOnSelect: 'field.userSelect($item, $model, $label, $event, fieldData)',
                typeaheadTemplateUrl: '/dekky.forms/themes/typeaheadUser/typeahead-match.html',
                typeaheadInputFormatter: 'field.formatLabel($model)'
            },
            fieldData: {
                clearBtn: true,
                refreshAutoComplete: function(name, term) {
                    return autocomplete.refreshAutoComplete(name, term);
                },
                userSelect: function($item, $model, $label, $event, parentItem) {
                    parentItem.email = $item.email;
                },
                formatLabel: function($model) {
                    if (angular.isObject($model)) {
                        return $model.fio;
                    } else {
                        return $model;
                    }
                }
            }
        }, autocomplete.get('ascentUsers'))
        .addField('email', null, {
            validators: {
                required: true
            },
            options: {
                class: 'form__item width-350',
                placeholder: 'E-mail участника'
            }
        });

    ascentModel
        .addField('ascent_date', 'dateDropdowns', {
            validators: { required: true }
        })
        .addField('ascent_mountain_peak', 'mountainPeakSelect', {
            options: {
                class: 'form__ui-select width-350'
            }
        })
        .addField('ascent_mountain_route', 'selectObject', {
            validators: {
                required: true
            },
            options: {
                defaultOption: 'Маршрут',
                onSelect: 'field.uiSelectOptions.onSelect($item)',
                class: 'form__item form__item_select width-350 margin_r_20'
            },
            ngOptions: 'item as item.name + " / " +item.mountain_route_complexity.name  for item in field.items track by item.id'
        }, [])
        .addField('ascent_type', 'selectObject', {
            validators: { required: false },
            options: {
                defaultOption: 'Способ восхождения',
                class: 'form__item width-350 margin_r_20 form__item_select'
            },
            ngOptions: 'item as item.name for item in field.items track by item.id'
        }, ascentTypes.list)
        .addField('instructor', 'userSelect', {
            validators: { required: false },
            options: {
                class: 'form__ui-select width-350 margin_b_20'
            },
            uiSelectOptions: {
                match: {
                    placeholder: 'Инструктор'
                },
                choices: {
                    refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Users", "instructor")'
                },
                refreshAutoComplete: autocomplete.refreshAutoComplete
            }
        }, autocomplete.get('instructor'))
        .addField('user_chief', 'userSelect', {
            validators: { required: false },
            options: {
                class: 'form__ui-select width-350 margin_b_20'
            },
            uiSelectOptions: {
                match: {
                    placeholder: 'Руководитель'
                },
                choices: {
                    refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Users", "userСhief")'
                },
                refreshAutoComplete: autocomplete.refreshAutoComplete
            }
        }, autocomplete.get('userСhief'))
        .addField('ascent_users', 'collection', {
            buttons: {
                add: 'Добавить участника',
                remove: 'Удалить'
            }
        }, userModel);

    reportModel
        .addField('club', 'uiSelect', {
            validators: {
                required: true
            },
            options: {
                onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                class: 'form__ui-select width-600'
            },
            uiSelectOptions: {
                matchTitle: '{{ $select.selected.name }} ',
                choicesTitle: '{{ item.name }}',
                match: {
                    placeholder: 'Федерация / Клуб',
                    allowClear: true
                },
                choices: {
                    repeat: 'item in field.items track by item.id',
                    refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Club", "club")',
                    refreshDelay: 0
                },
                refreshAutoComplete: autocomplete.refreshAutoComplete
            }
        }, autocomplete.get('club'))
        .addField('userChief', 'userSelect', {
            options: {
                class: 'form__ui-select width-350'
            },
            uiSelectOptions: {
                match: {
                    placeholder: 'Организатор, ФИО',
                    allowClear: true
                },
                choices: {
                    refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Users", "userChiefs")'
                },
                refreshAutoComplete: autocomplete.refreshAutoComplete
            }
        }, autocomplete.get('userChiefs'))
        .addField('userCoach', 'userSelect', {
            options: {
                class: 'form__ui-select width-350'
            },
            uiSelectOptions: {
                match: {
                    placeholder: 'Старший тренер',
                    allowClear: true
                },
                choices: {
                    refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Users", "userCoaches")'
                },
                refreshAutoComplete: autocomplete.refreshAutoComplete
            }
        }, autocomplete.get('userCoaches'))
        .addField('userSafety', 'userSelect', {
            options: {
                class: 'form__ui-select width-350'
            },
            uiSelectOptions: {
                match: {
                    placeholder: 'Ответственный за безопасность, ФИО',
                    allowClear: true
                },
                choices: {
                    refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Users", "userSafeties")'
                },
                refreshAutoComplete: autocomplete.refreshAutoComplete
            }
        }, autocomplete.get('userSafeties'))
        .addField('userInstructor', 'userSelect', {
            uiSelectOptions: {
                match: {
                    allowClear: true
                },
                choices: {
                    refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Users", "userInstructor")'
                },
                refreshAutoComplete: autocomplete.refreshAutoComplete
            }
        }, autocomplete.get('userInstructor'))
        .addField('userJuniorInstructor', 'userSelect', {
            uiSelectOptions: {
                match: {
                    allowClear: true
                },
                choices: {
                    refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Users", "userJuniorInstructor")'
                },
                refreshAutoComplete: autocomplete.refreshAutoComplete
            }
        }, autocomplete.get('userJuniorInstructor'))
        .addField('countUsersTotal', null, {
            'validators': {
                required: false,
                numericOnly: ''
            }
        })
        .addField('users_complite', 'collection', {
            buttons: {
                add: 'Добавить участника',
                remove: 'Удалить'
            }
        }, userModel)
        /*.addField('countUsersCc', null, {
            'validators': {
                required: true,
                numericOnly: ''
            }
        })
        .addField('countUsersCp', null, {
            'validators': {
                required: true,
                numericOnly: ''
            }
        })
        .addField('countUsersNp', null, {
            'validators': {
                required: true,
                numericOnly: ''
            }
        })
        .addField('countUsersCm', null, {
            'validators': {
                required: true,
                numericOnly: ''
            }
        })*/
        .addField('documentsFiles', 'fileUpload', {
            validators: {
                required: true
            },
            label: 'Загрузить файл',
            uploader: {
                url: Routing.generate('api_upload_post_file'),
                autoUpload: true,
                filters: [
                    fileUploadFilters.fileSize(),
                    fileUploadFilters.fileType()
                ],
                onSuccessItem: function (item, response) {
                    item.serverData = response;
                },
                onWhenAddingFileFailed: function(item, filter) {
                    var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';
                    showModalMessage(message);
                }
            }
        })
        .addField('ascents', 'collection', {
            buttons: {
                add: 'Добавить восхождение',
                remove: 'Удалить восхождение',
                save: 'Сохранить'
            }
        }, ascentModel);

    return reportModel;
});
